var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSequence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1375_16320)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.15 16.7983C13.15 17.2223 12.808 17.5579 12.376 17.5579H2.22395C1.80095 17.5579 1.44995 17.2134 1.44995 16.7983V9.49396C1.44995 9.07 1.79195 8.73438 2.22395 8.73438H12.376C12.799 8.73438 13.15 9.07884 13.15 9.49396V16.7983Z",
    stroke: "#CCCFD1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.72729 6.08789H15.1033C15.5263 6.08789 15.8773 6.42415 15.8773 6.84889V15.3526",
    stroke: "#CCCFD1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.40002 3.44141H17.7873C18.209 3.44141 18.55 3.7895 18.55 4.209V12.7061",
    stroke: "#CCCFD1",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3485 8.66602H2.25953C1.81853 8.66602 1.46753 9.01896 1.46753 9.44249V10.8543H13.1405V9.44249C13.1405 9.01013 12.7805 8.66602 12.3485 8.66602Z",
    fill: "#CCCFD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1375_16320"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15,
    fill: "white",
    transform: "translate(1 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSequence);
export default __webpack_public_path__ + "static/media/icon-sequence.5f36564e37e0a80ac482dbb82ceb7e4b.svg";
export { ForwardRef as ReactComponent };